export interface IApplicationGroup {
  id: string;
  name: string;
  description?: string | null;
}

export interface IGroupMappingItem {
  idpGroupId: string;
  applicationGroupId: string;
  applicationGroupName?: string;
}

export interface IUiGroupMapping {
  id: string;
  applicationGroupId: string;
  applicationGroupName: string;
  idpGroupId: string;
  idpGroupName: string;
}

export interface IApplicationGroupsResponse {
  groups: IApplicationGroup[];
}

export interface IGroupMappingsResponse {
  mappings: IGroupMappingItem[];
}

export function mappingRowId(
  applicationGroupId: string,
  idpGroupId: string,
): string {
  return `${applicationGroupId}:${idpGroupId}`;
}
